import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { BillingService, BillingInfoForUi } from 'src/app/services/billing.service';

@Component({
  selector: 'me-billing-menu-info',
  templateUrl: './billing-menu-info.component.html',
})
export class BillingMenuInfoComponent implements OnInit {

  billingInfo$: Observable<BillingInfoForUi | null> = this.$auth.organization$.pipe(
    map(org => {
      if (!org) {
        return null;
      }

      return this.$billing.getBillingDisplayInfo(org, { displayContext: 'menu' });
    })
  );

  constructor(
    private $auth: AuthService,
    private $billing: BillingService
  ) {}

  ngOnInit() {
  }

  onAction() {
    this.$billing.manageBilling();
  }
}
